import store from '../'

let resource = store.defineResource({
  name: "annotationColors"
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/annotation-colors.js